export default __webpack_public_path__ + "static/media/ic-transaction.09df096b.svg";